var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45 17.9375C1.91375 17.9375 1.45469 17.7533 1.07281 17.3848C0.690937 17.0163 0.5 16.5734 0.5 16.0559V2.88487C0.5 2.36743 0.690937 1.92448 1.07281 1.556C1.45469 1.18753 1.91375 1.00329 2.45 1.00329H10.25V2.88487H2.45V16.0559H16.1V9.4704H18.05V16.0559C18.05 16.5734 17.8591 17.0163 17.4772 17.3848C17.0953 17.7533 16.6362 17.9375 16.1 17.9375H2.45ZM3.425 14.1743H15.125L11.4688 9.4704L8.54375 13.2336L6.35 10.4112L3.425 14.1743ZM15.125 7.58882V3.66102L13.565 5.14276L12.2 3.82566L16.1 0.0625L20 3.82566L18.635 5.14276L17.075 3.66102V7.58882H15.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/Image-Upload.6b2a73bb0271936239c80d957cfe1d20.svg";
export { ForwardRef as ReactComponent };